module.exports = __webpack_public_path__ + "img/activity-20190918.93a64c42.jpg";